import React, { useState, useEffect } from 'react';
import './RightNavBar.css';

// Advanced SWE comment
// Hi!

const RightNavBar = ({ children }) => {
    const [ mobile, setMobile ] = useState(false);
    const [ tablet, setTablet ] = useState(false);
    const responsiveRightNavbar = () => {
        if (window.innerWidth <= 1277) {
            if (window.innerWidth <= 960) {
                setMobile(true);
                setTablet(false);
            }
            else {
                setTablet(true);
                setMobile(false);
            }
        }
        else {
            setMobile(false);
            setTablet(false);
        }
    };

    useEffect(() => { responsiveRightNavbar() }, []);
    window.addEventListener('resize', responsiveRightNavbar);

    return (
        <div className='right-navbar' key={"2345"}>
            {!mobile && (<div className='right-navbar-header'>
              {!tablet && <img src='/images/close-up.jpg' alt='Maria'></img>}
              <ul className='description-card'>
                <li className='bold-element' key={"0"}>
                    <i className='fa fa-angle-right'></i>
                    Maria
                </li>
                <li className='bold-element' key={"1"}>
                    <i className='fa fa-angle-right'></i>
                    <span className='email'>mb4767@columbia.edu</span>
                </li>
                <li key={"2"}>
                    <i className='fa fa-angle-right'></i>
                    Columbia University
                </li>
                <li key={"3"}>
                    <i className='fa fa-angle-right'></i>
                    MS in CS
                </li>
                <li key={"4"}>
                    <i className='fa fa-angle-right'></i>
                    <a href="https://www.linkedin.com/in/mariabarbulescu" target="_black"><i className='fa fa-linkedin' /></a>
                </li>
              </ul>
            </div>)}
            <div className="page-rightnavbar">{children}</div>
        </div>
    )
}

export default RightNavBar;